import Config from './config';

import Assets from '@app/assets';

import LaunchDarkly from '@module/launchdarkly';

import { OSLO_GRAY } from '@constant/colors';

let snippetLoaded = false;
let snippetLoading = false;
const loadSnippet = () => {
  return new Promise((resolve, reject) => {
    if (snippetLoading) {
      return reject();
    }

    if (snippetLoaded) {
      return resolve();
    }

    snippetLoading = true;
    const z = (window.$zopim = function (c) {
      z._.push(c);
    });
    const $ = (z.s = window.document.createElement('script'));
    z.set = function (o) {
      z.set._.push(o);
    };
    z._ = [];
    z.set._ = [];
    $.async = !0;
    $.setAttribute('charset', 'utf-8');
    $.src = Config.source;
    z.t = +new Date();
    $.type = 'text/javascript';
    $.addEventListener(
      'load',
      () => {
        snippetLoaded = true;
        snippetLoading = false;
        window.$zopim(resolve);
      },
      false
    );
    $.addEventListener(
      'error',
      () => {
        reject();
        snippetLoaded = false;
        snippetLoading = false;
      },
      false
    );
    // Append in document
    document.body.appendChild($);
  });
};

const zopim = {
  hideAll() {
    return window.$zopim.livechat.hideAll();
  },

  isReady() {
    return snippetLoaded;
  },

  onChatStart(callback) {
    return window.$zopim.livechat.setOnChatStart(callback);
  },

  onUnreadMessages(callback) {
    return window.$zopim.livechat.setOnUnreadMsgs(callback);
  },

  onWindowShow(callback) {
    return window.$zopim.livechat.window.onShow(callback);
  },

  onWindowHide(callback) {
    return window.$zopim.livechat.window.onHide(callback);
  },

  setDepartment(department) {
    return window.$zopim.livechat.departments.setVisitorDepartment(department);
  },

  setOnlineFormGreeting(greeting) {
    return window.$zopim.livechat.prechatForm.setGreetings(greeting);
  },

  setOfflineFormGreeting(greeting) {
    return window.$zopim.livechat.offlineForm.setGreetings(greeting);
  },

  setTheme({ color }) {
    const { theme } = window.$zopim.livechat;
    theme.setColor(color);
    theme.reload();
    return;
  },

  setTitle(title) {
    return window.$zopim.livechat.window.setTitle(title);
  },

  setupConcierge({ image, name, jobTitle }) {
    const { concierge } = window.$zopim.livechat;
    concierge.setAvatar(image);
    concierge.setName(name);
    concierge.setTitle(jobTitle);
    return;
  },

  showPopupChat() {
    return window.$zopim.livechat.window.openPopout();
  },

  showWindow() {
    return window.$zopim.livechat.window.show();
  },

  showInlineChat() {
    const { livechat } = window.$zopim;
    livechat.theme.setFontConfig({}, 'Helvetica, Arial');
    livechat.theme.setColor(OSLO_GRAY);
    livechat.window.setSize('large');
    livechat.window.setTitle('WeTransfer');
    livechat.window.setOffsetHorizontal(40);
    livechat.button.setOffsetHorizontal(40);
    livechat.appendNotes(JSON.stringify(LaunchDarkly.getAllFlags()));
    livechat.concierge.setAvatar(Assets.lookup('wt-facebook-s.png'));
    livechat.setDisableSound(true);
    // API does not support configuration of Message Style = Simple Lines
    // So this must be done in the UI https://dashboard.zopim.com/#widget/appearance

    return livechat.window.show();
  },

  setVisitorSettings(settings = {}) {
    return window.$zopim.livechat.set(settings);
  },

  setVisitorPath(url = '', title = '') {
    return window.$zopim.livechat.sendVisitorPath({
      url,
      title,
    });
  },

  tag(...args) {
    return window.$zopim.livechat.addTags(...args);
  },
};

// Pre-hook to check if $zopim is set in window object
Object.keys(zopim).forEach((key) => {
  const func = zopim[key];
  zopim[key] = (...args) => {
    if (window.$zopim) {
      return func(...args);
    }
    return false;
  };
});

export { loadSnippet };
export default zopim;
